import React from 'react'

import TagCustom from './tag'
import { useDispatch } from 'react-redux'
import './style.css'
import { removeService } from '../../../../commons/redux/actions/service.action'
export default function ItemService({
  price,
  kind,
  time,
  date,
  district,
  town,
  desc,
  user_id,
  code,
  _id,
}) {
  const dispatch = useDispatch()
  const remove = async () => {
    try {
      const res = await dispatch(removeService(_id))
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <div className="border m-3 p-3 rounded">
        <p className="h-2 w-2 bg-red-500 ml-auto rounded-full"></p>
        <h1 className="titreItem">Service details</h1>
        <div className="flex">
          {' '}
          <p className="text text-sm font-bold">
            {desc ? desc : '<p>Description non defini</p>'}{' '}
          </p>
        </div>
        <div className="flex p-2 flex-wrap justify-content-center text-center align-items-center align-content-center">
          <div>
            <p className="text-xs text-muted">Budget</p>

            <TagCustom size={'md'} price={price + ''} colorScheme="red" />
          </div>
          <div>
            <p className="text-xs text-muted">Adresse</p>
            <TagCustom size={'md'} price={user_id?.town} colorScheme="cyan" />
            <TagCustom
              size={'md'}
              price={user_id?.district}
              colorScheme="blue"
            />
          </div>
          <div>
            <p className="text-xs text-muted">Moment</p>
            <TagCustom size={'md'} price={date} colorScheme="red" />
            <TagCustom size={'md'} price={time} colorScheme="blue" />
          </div>
          <div>
            <p className="text-xs text-muted">Type</p>
            <TagCustom size={'md'} price={kind} colorScheme="red" />
          </div>
        </div>
        <div className="flex text-xs justify-content-right align-items-center">
          <h3 className="text-black font-bold">CodeID :</h3>
          <p>{code ? code : 'DFT'}</p>
        </div>
        <hr className="mx-auto" />
        <div className="text-xs text-muted p-2">
          <div className="text-black text-center font-bold text-xs">
            <h2>Client</h2>
          </div>
          <div className="flex justify-content-between">
            <h6>Nom :</h6>
            <p className="font-bold text-black">{user_id?.name}</p>
          </div>

          <div className="flex justify-content-between">
            <h6>Tel :</h6>
            <p className="font-bold text-black">{user_id?.tel}</p>
          </div>
          <div className="flex justify-content-between">
            <h6>Email :</h6>
            <p className="font-bold text-black">{user_id?.email}</p>
          </div>
          <div className="flex justify-content-between">
            <h6>Commande(s) :</h6>
            <p className=" rounded-full bg-light border text-center px-2  h-5">
              {user_id?.commande.length}
            </p>
          </div>
          <button
            onClick={() => remove()}
            className="btn btn-sm btn-danger text-xs font-bold"
          >
            Supprimer
          </button>
          <a
            href={`/my.match/${user_id.town}/${user_id.district}`}
            className="btn btn-sm btn-info ml-2 text-xs font-bold"
          >
            Voir les partenaires{' '}
          </a>
        </div>
      </div>
    </>
  )
}
